
var $container = $('.b-masonry');
$container.masonry({
  itemSelector: '.b-masonry__item',
  columnWidth: '.b-masonry__item',
  percentPosition: true
}).masonry('reload');


// WEBPACK FOOTER //
// ./src/js/pages/one-theme/all-exponats.js